// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/mail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Images/location.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Images/facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/linkedin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Images/youtube.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer-section__wLV3j {
  width: 100%;
  min-height: 60vh;
  padding-top: 150px;
  background-color: #252626;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background-image: url("https://i.imgur.com/Te2gUYc.png");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: auto 100%;
}

.Footer_icon__XvV8Y {
  width: 257px;
  height: 116px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 530px;
}

.Footer_paragraphs__RCM1I {
  width: 300px;
  margin-left: 200px;
}

.Footer_paragraphs__RCM1I h3,
h4,
h2,
h5 {
  color: #fff;
  text-align: start;
  font-weight: 700;
  font-size: 32px;
  font-family: "Roboto", sans-serif;
}

.Footer_paragraphs__RCM1I h3 {
  margin-bottom: 120px;
  font-family: "Roboto", sans-serif;
}

.Footer_paragraphs__RCM1I p {
  text-align: start;
  color: #fff;
  font-size: 24px;
  font-weight: 200;
  font-family: "Roboto", sans-serif;
}

.Footer_paragraphs__RCM1I p:nth-child(5) {
  margin-bottom: 100px;
}

.Footer_paragraphs__RCM1I p:nth-child(10) {
  margin-bottom: 100px;
}

.Footer_contact-info__dLbkw {
  width: 375px;
  height: auto;
  margin-left: 200px;
}

.Footer_contact-info__dLbkw p {
  display: flex;
  align-items: center;
  color: white;
  font-weight: 700;
  font-size: 23px;
  font-family: "Roboto", sans-serif;
}

.Footer_phone-icon__48wlV,
.Footer_mail-icon__S0suh,
.Footer_location-icon__GPLTC {
  width: 30px;
  height: 33px;
  background-size: cover;
  background-repeat: no-repeat;
}

.Footer_phone-icon__48wlV {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.Footer_mail-icon__S0suh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.Footer_location-icon__GPLTC {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.Footer_iconses__IGpOj {
  width: 80%;
  height: 100px;
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  text-align: start;
}

.Footer_facebook-icon__ns92B {
  width: 42px;
  height: 42px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}

.Footer_linkedin-icon__Z-tz3 {
  width: 42px;
  height: 42px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}

.Footer_youtube-icon__iOJuw {
  width: 42px;
  height: 42px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}

.Footer_hr__WSMz9 {
  width: 80%;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.2509803922);
  margin: auto;
  margin-bottom: 20px;
}

.Footer_bg-img__m7Khv {
  display: none;
}

@media screen and (max-width: 1400px) {
  .Footer_footer-section__wLV3j {
    flex-direction: column;
    align-items: center;
    background-position: center bottom;
    background-size: 100% auto;
    padding: 80px 20px;
  }
  .Footer_icon__XvV8Y {
    margin: 0 auto 40px auto;
  }
  .Footer_paragraphs__RCM1I {
    margin-left: 0;
    width: 100%;
    max-width: 500px;
  }
  .Footer_contact-info__dLbkw {
    margin-left: 0;
    width: 100%;
    max-width: 500px;
    margin-top: 50px;
  }
  .Footer_contact-info__dLbkw p {
    font-size: 24px;
  }
  .Footer_iconses__IGpOj {
    justify-content: center;
    gap: 20px;
  }
  .Footer_hr__WSMz9 {
    width: 90%;
  }
}
@media screen and (max-width: 600px) {
  .Footer_phone-icon__48wlV {
    width: 23px;
    height: 25px;
  }
  .Footer_mail-icon__S0suh {
    width: 23px;
    height: 25px;
  }
  .Footer_location-icon__GPLTC {
    width: 23px;
    height: 25px;
  }
  .Footer_paragraphs__RCM1I h3,
  h4,
  h2,
  h5 {
    font-size: 24px;
    font-family: "Roboto", sans-serif;
  }
  .Footer_paragraphs__RCM1I p,
  .Footer_contact-info__dLbkw p {
    font-size: 18px;
    font-family: "Roboto", sans-serif;
  }
  .Footer_icon__XvV8Y {
    width: 180px;
    height: 90px;
  }
  .Footer_facebook-icon__ns92B {
    width: 40px;
    height: 40px;
  }
}
/* ========== RESPONSIVE DESIGN ========== */
@media screen and (max-width: 1024px) {
  .Footer_footer-section__wLV3j {
    flex-direction: column;
    align-items: center;
    background-position: center bottom;
    background-size: 100% auto;
    padding: 80px 20px;
  }
  .Footer_icon__XvV8Y {
    margin: 0 auto 40px auto;
  }
  .Footer_paragraphs__RCM1I {
    margin-left: 0;
    width: 100%;
    max-width: 500px;
  }
  .Footer_contact-info__dLbkw {
    margin-left: 0;
    width: 100%;
    max-width: 500px;
    margin-top: 50px;
  }
  .Footer_contact-info__dLbkw p {
    font-size: 24px;
  }
  .Footer_iconses__IGpOj {
    justify-content: center;
    gap: 20px;
  }
  .Footer_hr__WSMz9 {
    width: 90%;
  }
}
@media screen and (max-width: 600px) {
  .Footer_paragraphs__RCM1I h3,
  h4,
  h2,
  h5 {
    font-size: 24px;
  }
  .Footer_paragraphs__RCM1I p,
  .Footer_contact-info__dLbkw p {
    font-size: 18px;
  }
  .Footer_icon__XvV8Y {
    width: 180px;
    height: 90px;
  }
  .Footer_facebook-icon__ns92B {
    width: 40px;
    height: 40px;
  }
  .Footer_youtube-icon__iOJuw {
    width: 40px;
    height: 40px;
  }
  .Footer_linkedin-icon__Z-tz3 {
    width: 40px;
    height: 40px;
  }
  .Footer_icon__XvV8Y {
    margin-left: 50px;
  }
  .Footer_contact-info__dLbkw {
    width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Fotter/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EAGA,wDAAA;EACA,4BAAA;EACA,iCAAA;EACA,0BAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;AADF;;AAIA;;;;EAIE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AADF;;AAIA;EACE,oBAAA;EACA,iCAAA;AADF;;AAIA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AADF;;AAIA;;;EAGE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;AADF;;AAIA;EACE,yDAAA;AADF;;AAKA;EACE,yDAAA;AAFF;;AAKA;EACE,yDAAA;AAFF;;AAKA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;AAFF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;AAHF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;AAJF;;AAOA;EACE,UAAA;EACA,WAAA;EACA,mDAAA;EACA,YAAA;EAEA,mBAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,kCAAA;IACA,0BAAA;IACA,kBAAA;EALF;EAQA;IACE,wBAAA;EANF;EASA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;EAPF;EAUA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;EARF;EAWA;IACE,eAAA;EATF;EAYA;IACE,uBAAA;IACA,SAAA;EAVF;EAaA;IACE,UAAA;EAXF;AACF;AAcA;EAYE;IACE,WAAA;IACA,YAAA;EAvBF;EAyBF;IACE,WAAA;IACA,YAAA;EAvBA;EAyBA;IACE,WAAA;IACA,YAAA;EAvBF;EA0BA;;;;IAIE,eAAA;IACA,iCAAA;EAxBF;EA2BA;;IAEE,eAAA;IACA,iCAAA;EAzBF;EA4BA;IACE,YAAA;IACA,YAAA;EA1BF;EA6BA;IACE,WAAA;IACA,YAAA;EA3BF;AACF;AA+BA,4CAAA;AACA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,kCAAA;IACA,0BAAA;IACA,kBAAA;EA7BF;EAgCA;IACE,wBAAA;EA9BF;EAiCA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;EA/BF;EAkCA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;EAhCF;EAmCA;IACE,eAAA;EAjCF;EAoCA;IACE,uBAAA;IACA,SAAA;EAlCF;EAqCA;IACE,UAAA;EAnCF;AACF;AAsCA;EACE;;;;IAIE,eAAA;EApCF;EAuCA;;IAEE,eAAA;EArCF;EAwCA;IACE,YAAA;IACA,YAAA;EAtCF;EAyCA;IACE,WAAA;IACA,YAAA;EAvCF;EA0CA;IACE,WAAA;IACA,YAAA;EAxCF;EA2CA;IACE,WAAA;IACA,YAAA;EAzCF;EAkDA;IAEE,iBAAA;EAjDF;EAmDA;IAEE,UAAA;EAlDF;AACF","sourcesContent":[".footer-section {\n  width: 100%;\n  min-height: 60vh;\n  padding-top: 150px;\n  background-color: #252626;\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n  //justify-content: space-between;\n\n  background-image: url(\"https://i.imgur.com/Te2gUYc.png\");\n  background-repeat: no-repeat;\n  background-position: right bottom;\n  background-size: auto 100%;\n}\n\n.icon {\n  width: 257px;\n  height: 116px;\n  background-image: url(\"../Images/icon.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin-left: 530px;\n}\n\n.paragraphs {\n  width: 300px;\n  margin-left: 200px;\n}\n\n.paragraphs h3,\nh4,\nh2,\nh5 {\n  color: #fff;\n  text-align: start;\n  font-weight: 700;\n  font-size: 32px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraphs h3 {\n  margin-bottom: 120px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraphs p {\n  text-align: start;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 200;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraphs p:nth-child(5) {\n  margin-bottom: 100px;\n}\n\n.paragraphs p:nth-child(10) {\n  margin-bottom: 100px;\n}\n\n.contact-info {\n  width: 375px;\n  height: auto;\n  margin-left: 200px;\n}\n\n.contact-info p {\n  display: flex;\n  align-items: center;\n  color: white;\n  font-weight: 700;\n  font-size: 23px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.phone-icon,\n.mail-icon,\n.location-icon {\n  width: 30px;\n  height: 33px;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.phone-icon {\n  background-image: url(\"../Images/phone.svg\");\n\n}\n\n.mail-icon {\n  background-image: url(\"../Images/mail.svg\");\n}\n\n.location-icon {\n  background-image: url(\"../Images/location.svg\");\n}\n\n.iconses {\n  width: 80%;\n  height: 100px;\n  margin-top: 80px;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  text-align: start;\n}\n\n.facebook-icon {\n  width: 42px;\n  height: 42px;\n  background-image: url(\"../Images/facebook.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n\n}\n\n.linkedin-icon {\n  width: 42px;\n  height: 42px;\n  background-image: url(\"../Images/linkedin.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n\n}\n\n.youtube-icon {\n  width: 42px;\n  height: 42px;\n  background-image: url(\"../Images/youtube.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.hr {\n  width: 80%;\n  height: 3px;\n  background-color: #ffffff40;\n  margin: auto;\n  //margin-top: 50px;\n  margin-bottom: 20px;\n}\n\n.bg-img {\n  display: none; // մենք հիմա օգտագործում ենք background-image, այս div պետք չի\n}\n\n@media screen and (max-width: 1400px) {\n  .footer-section {\n    flex-direction: column;\n    align-items: center;\n    background-position: center bottom;\n    background-size: 100% auto;\n    padding: 80px 20px;\n  }\n\n  .icon {\n    margin: 0 auto 40px auto;\n  }\n\n  .paragraphs {\n    margin-left: 0;\n    width: 100%;\n    max-width: 500px;\n  }\n\n  .contact-info {\n    margin-left: 0;\n    width: 100%;\n    max-width: 500px;\n    margin-top: 50px;\n  }\n\n  .contact-info p {\n    font-size: 24px;\n  }\n\n  .iconses {\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .hr {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n\n  //.contact-info{\n  //  display: flex;\n  //  flex-wrap: wrap;\n  //  justify-content: center;\n  //  align-items: center;\n  //  justify-content: start;\n  //\n  //}\n\n  .phone-icon{\n    width: 23px;\n    height: 25px;\n  }\n.mail-icon{\n  width: 23px;\n  height: 25px;\n}\n  .location-icon{\n    width: 23px;\n    height: 25px;\n  }\n\n  .paragraphs h3,\n  h4,\n  h2,\n  h5 {\n    font-size: 24px;\n    font-family: 'Roboto', sans-serif;\n  }\n\n  .paragraphs p,\n  .contact-info p {\n    font-size: 18px;\n    font-family: 'Roboto', sans-serif;\n  }\n\n  .icon {\n    width: 180px;\n    height: 90px;\n  }\n\n  .facebook-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n}\n\n/* ========== RESPONSIVE DESIGN ========== */\n@media screen and (max-width: 1024px) {\n  .footer-section {\n    flex-direction: column;\n    align-items: center;\n    background-position: center bottom;\n    background-size: 100% auto;\n    padding: 80px 20px;\n  }\n\n  .icon {\n    margin: 0 auto 40px auto;\n  }\n\n  .paragraphs {\n    margin-left: 0;\n    width: 100%;\n    max-width: 500px;\n  }\n\n  .contact-info {\n    margin-left: 0;\n    width: 100%;\n    max-width: 500px;\n    margin-top: 50px;\n  }\n\n  .contact-info p {\n    font-size: 24px;\n  }\n\n  .iconses {\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .hr {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .paragraphs h3,\n  h4,\n  h2,\n  h5 {\n    font-size: 24px;\n  }\n\n  .paragraphs p,\n  .contact-info p {\n    font-size: 18px;\n  }\n\n  .icon {\n    width: 180px;\n    height: 90px;\n  }\n\n  .facebook-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .youtube-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .linkedin-icon {\n    width: 40px;\n    height: 40px;\n  }\n  // .icon{\n  //   margin-left: 80px;\n  // }\n  //.contact-info{\n  //  margin-left: 70px;\n\n  //}\n  .icon {\n    //background-color: red;\n    margin-left: 50px;\n  }\n  .contact-info {\n    //background-color: red;\n    width: 70%;\n  }\n  //.contact-info div{\n  //  justify-content: space-around;\n  //}\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-section": `Footer_footer-section__wLV3j`,
	"icon": `Footer_icon__XvV8Y`,
	"paragraphs": `Footer_paragraphs__RCM1I`,
	"contact-info": `Footer_contact-info__dLbkw`,
	"phone-icon": `Footer_phone-icon__48wlV`,
	"mail-icon": `Footer_mail-icon__S0suh`,
	"location-icon": `Footer_location-icon__GPLTC`,
	"iconses": `Footer_iconses__IGpOj`,
	"facebook-icon": `Footer_facebook-icon__ns92B`,
	"linkedin-icon": `Footer_linkedin-icon__Z-tz3`,
	"youtube-icon": `Footer_youtube-icon__iOJuw`,
	"hr": `Footer_hr__WSMz9`,
	"bg-img": `Footer_bg-img__m7Khv`
};
export default ___CSS_LOADER_EXPORT___;
